// src/app/core/interceptors/base-url.interceptor.ts
import { inject } from '@angular/core';
import { HttpInterceptorFn } from '@angular/common/http';
import { API_BASE_URL } from '../app-config.token';

const ABSOLUTE = /^https?:\/\//i;

export const baseUrlInterceptor: HttpInterceptorFn = (req, next) => {
  // ignora URLs absolutas o recursos locales
  if (ABSOLUTE.test(req.url) || req.url.startsWith('/assets') || req.url.startsWith('data:') || req.url.startsWith('blob:')) {
    return next(req);
  }
  const base = inject(API_BASE_URL) ?? '';
  const url = `${base.replace(/\/+$/,'')}/${req.url.replace(/^\/+/,'')}`;
  return next(req.clone({ url }));
};
